import { render, staticRenderFns } from "./LmFormBuilderUi.vue?vue&type=template&id=d9ef6674&scoped=true&"
import script from "./LmFormBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmFormBuilderUi.vue?vue&type=script&lang=js&"
import style0 from "./LmFormBuilderUi.vue?vue&type=style&index=0&id=d9ef6674&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ef6674",
  null
  
)

export default component.exports